import { createSlice } from '@reduxjs/toolkit';

const parseRoles = (roles) => {
    if (!roles) return [];
    if (Array.isArray(roles)) return roles;
    try {
        return JSON.parse(roles.replace(/'/g, '"').replace(/,(\s*])/, '$1'));
    } catch {
        return [];
    }
};

const hasManagerRoleForSchool = (roles, schoolId) => {
    if (!schoolId) return false;
    const schoolRoles = parseRoles(roles)
        .filter(r => String(r.mosadId) === String(schoolId))
        .map(r => String(r.role));
    return window.config?.managerRoles?.some(id => schoolRoles.includes(id)) ?? false;
};

const initialState = {
    isAuth: null,
    isStudent: null,
    isManager: null,
    userDetails: null,
    fetchAuthFinish: null,
    loading: false,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout(state, action) {
            state.user = action.payload.user;
            state.isAuth = action.payload.isAuth;
        },
        init(state, action) {
            state.isAuth = action.payload.isAuth;
            state.user = action.payload.claims ? Object.assign({}, ...action.payload.claims.map(x => { return { [x.type]: x.value } })) : null;
            state.isAdmin = action.payload.user?.isAdmin;
            state.isStudent = state.user?.isstudent === 'Yes' ? true : false;
            state.isManager = false;
            state.fetchAuthFinish = true;
        },
        setUserDetails(state, action) {
            state.userDetails = action.payload
        },
        updateUserClaims(state, action) {
            if (action.payload)
                state.user = { ...state.user, ...action.payload }
        },
        setDefaultSchool(state, action) {
            state.userDetails = { ...state.userDetails, defaultSchool: action.payload }
            state.isManager = hasManagerRoleForSchool(state.user?.roles, action.payload?.id);
        },
        mergeDefaultSchoolData(state, action) {
            const existingSchool = state.userDetails?.defaultSchool;
            state.userDetails = {
                ...state.userDetails,
                defaultSchool: {
                    ...existingSchool,
                    ...action.payload,
                    isSchoolAdmin: action.payload.isSchoolAdmin ?? existingSchool?.isSchoolAdmin,
                }
            }
            state.isManager = hasManagerRoleForSchool(state.user?.roles, existingSchool?.id);
        },
        setLoading(state, action) {
            state.loading = action.payload;
        },
    }
})

export const authActions = authSlice.actions;
export default authSlice
